export default __webpack_public_path__ + "static/tools-61313f280698af3d45e16df9e64e8cee.svg";